export const MIN_CUIL = 20000000001;
export const MAX_CUIL = 27999999999;

export const ROLES = [
    {
        id: 1,
        nombre: 'ADMINISTRADOR_BACKOFFICE',
    },
    {
        id: 6,
        nombre: 'PREVENTOR',
    },
    {
        id: 4,
        nombre: 'ASEGURADORA_VIEWER',
    }
]

export const BACKOFFICE = 'BACKOFFICE';
export const ART = 'ART';
export const SIMP = 'SIMP';
export const PERFILES = [ART, SIMP];

export const GRV = 'GRV';